import React from "react";
import { NavLink } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import Table from "react-bootstrap/Table";
import { FaList, FaCog, FaPencilAlt, FaClone, FaTrash } from "react-icons/fa";
import Select from "react-select";
import Button from "react-bootstrap/Button";

import ReportAPI from "../../api/ReportAPI";
import withRouter from "../../util/WithRouter";
import Util from "../../util/Util";
import Const from "../../util/Constants";
import ApiUiController from "../../controller/ApiUiController";
import FieldController from "../../controller/FieldController";
import { Form, FormControl } from "react-bootstrap";
import ConsolidatedActivityReport from "../report/consolidatedFixedReport/consolidatedActivityReport";
import ColdDataApi from "../../api/ColdDataApi";
import Moment from "moment";

class ColdDataImport extends React.Component {

  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Const.Model);
    this.options = model
      ? model.user?.options
          ?.filter((user) => user.status === Const.Active)
          .map((salesPerson) => ({
            label: salesPerson?.label,
            value: salesPerson?.id,
          }))
      : [];

    this.state = {
      inApiCall: false,
      csvFile: null,
      batchSize: 200,
      csvData: [],
      recentlyAdded: [],
      selections: [],
      inValid: {},
    };
  }

  onDemoDownload = () => {
    let csv = 'Name , Phone';
    const element = document.createElement('a');
    element.href = URL.createObjectURL(new Blob([csv], {type: 'text/plain'}));
    element.download = 'Demo Upload.csv';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  onListSuccess = (res) => {
    // Add sales perosn name instead of id
    const updatedList = res.map((res) => ({
      ...res,
      salesPerson: this.options.find((opt) => opt.value === res.salesPerson)
        .label,
    }));

    const sorted = updatedList.sort((a, b) => {
      if (!a.salesPerson && b.salesPerson) return -1;
      if (a.salesPerson && !b.salesPerson) return 1;
      return 0;
    });
    this.setState({ inApiCall: false, recentlyAdded: sorted });
  };

  onListFail = (err) => {
    const error = JSON.parse(err);
    this.setState({ inApiCall: false });
    Util.showNotification(
      "Failure",
      error?.message || "Something went wrong",
      "danger"
    );
  };

  onFileChange = (event) => {
    const csvFile = event.target.files[0];
    if (!csvFile) return;
    this.setState({ inApiCall: true, csvFile });
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const csvText = e.target.result;
      const rows = csvText.trim().split("\n");
      const headers = rows[0].split(",").map((h) => h.trim().toLowerCase());
      const expectedHeaders = ["name", "phone number"];

      const isValidHeader = expectedHeaders.every((header) =>
        headers.includes(header)
      );

      if (!isValidHeader) {
        Util.showError("CSV must have Name and Phone Number columns.");
        this.setState({ inApiCall: false, csvFile: null, csvData: [] });
        return;
      }

      const data = rows.slice(1).map((row) => {
        const values = row.split(",").map((v) => v.trim());
        return {
          name: values[headers.indexOf("name")],
          phoneNumber: values[headers.indexOf("phone number")],
          salesPerson: "",
        };
      });

      this.setState({ csvData: data, inApiCall: false });
    };
    fileReader.readAsText(csvFile);
  };

  onBatchSizeChange = (event) => {
    let value = Number(event.target.value);

    if (value < 10) value = 10;
    if (value > 500) value = 500;

    this.setState({ batchSize: value });
  };

  onSalesExecutiveChange = (event) => {
    this.setState({ selections: event });
  };

  onImport = async () => {
    const { csvFile, selections, batchSize, csvData } = this.state;

    if (!csvFile) {
      Util.showError("CSV file required");
      return;
    }

    if (selections.length === 0) {
      Util.showError("Sales executive required");
      return;
    }

    const numberOfSalespersons = selections.length;
    const requiredRecords = batchSize * numberOfSalespersons;
    if (csvData.length < requiredRecords) {
      Util.showError(
        `CSV must contain at least ${requiredRecords} records for ${numberOfSalespersons} salesperson(s) with batch size ${batchSize}. Currently only ${csvData.length} records found.`
      );
      return;
    }

    let offset = 0;
    this.setState({ inApiCall: true });
    try {
      for (let salesPerson of selections) {
        const campaignName = `Campaign_${salesPerson.label}_${Moment().format("DD_MM_YYYY")}`;

        const batchRows = csvData.slice(offset, offset + batchSize);
        offset += batchSize;
        const rowsWithMeta = batchRows.map((r) => ({
          ...r,
          salesPerson: salesPerson.value,
          // campaignId,
        }));

        // This creates campaign of each batch, and insert rows in cold data module
        await ColdDataApi.insertCampaignAsync({
          campaignName,
          salesPersonId: salesPerson.value,
          coldData: rowsWithMeta,
        });
      }

      this.loadList();
      this.setState({ csvData: [] });
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      this.setState({ inApiCall: false });
    }
  };

  render() {
    const { inApiCall, batchSize, csvData, recentlyAdded, selections } =
      this.state;

    return (
      <div className="sectionform" style={{ paddingBottom: "2rem" }}>
        <div className="container form-cont">
          <ApiUiController inApiCall={inApiCall}>
            <div className="row">
              <div className="col-md-6">
                <p className="mb-0" style={{ fontSize: "2rem" }}>
                  <small>CSV Import</small>
                </p>
                <Button variant="success" onClick={this.onDemoDownload} className="pt-2 pb-2 ml-0 mr-0">Demo CSV</Button>
                <FormControl
                  accept=".csv"
                  type="file"
                  onChange={this.onFileChange}
                  className="pt-2 pb-2"
                />
                <p>
                  <small>Only CSV Format Supported</small>
                </p>

                <Form.Group className="mt-3">
                  <Form.Label>Batch Size</Form.Label>
                  <FormControl
                    type="number"
                    maxLength={3}
                    min={10}
                    max={500}
                    value={batchSize}
                    onChange={this.onBatchSizeChange}
                  />
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Label>Sales Executive</Form.Label>
                  <Select
                    value={this.state.selections}
                    onChange={this.onSalesExecutiveChange}
                    options={this.options}
                    isDisabled={false}
                    isSearchable={true}
                    isClearable={true}
                    isMulti={true}
                  />
                </Form.Group>

                <div className="text-center btnsend mt-3">
                  <Button variant="success" onClick={this.onImport}>
                    Import
                  </Button>
                </div>
              </div>
            </div>  
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(ColdDataImport);
